Profiling.Dashboard ||= {}

class Profiling.Dashboard.ResultsView extends Backbone.View
  PROFILES_PER_PAGE = 10

  events:
    # 'click #export_excel': '_exportExcel'
    # 'click #export_word': '_exportWord'
    # 'click .exportable-fields-option': '_showExportableFieldsOption'
    'click #massive_tagging': '_onMassiveTagging'
    'click #social_users_export_excel': '_socialUsersExportExcel'
    'click #refresh': '_refresh'

  initialize: (@options = {}) ->
    @searchQuery = {}
    @session = @options.session
    @currentUser = @options.currentUser
    @accountSettings = @options.accountSettings
    @customerData = @options.customerData
    @config = @options.config
    @page = 0
    # @realtimeContentCheckerView = destroy: ->
    @RETRIES_FOR_TIMEOUT = 2
    @eventAggregator.bind('filterApplied', (count) => @contentsCount = count)
    # @eventAggregator.bind('change', @orderUpdate)

  download: (event) =>
    $(event.currentTarget).hide()
    @$el.find('#export').show()

  destroy: ->
    @remove()

  render: ->
    @$el.html(@template(self: @))
    # @delegateEvents()
    @$resultsContainer = @$el.find('#current_results')
    @$previousResultsContainer = @$el.find('#previous_results')
    @massiveTaggingView = new MassiveTagging.Views.MassiveTaggingView
      searchQuery: attributes: @_getSessionOptions()
      updateJobClass: Profiling.AsyncJob
    @$el.append(@massiveTaggingView.render().el)
    @

  getRemaining:() =>
    @page

  orderByUpdate:(target) ->
    order_by = target.target[target.currentTarget.selectedIndex].value
    @orderUpdate(order_by)

  orderBy: ->
    try
      Object.keys(@session.order)[0]
    catch
      'created_at'

  sortOrder: ->
    try
      if @session.order[@orderBy()] == 'desc' then 'desc' else 'asc'
    catch
      'desc'

  orderDirectionUpdate: (target) ->
    order_by = @orderBy()
    order = if @sortOrder() == 'desc' then 'asc' else 'desc'
    @session.order[order_by] = order
    @_refresh()

  orderUpdate:(order_by) ->
    order_by ||= @orderBy()
    order = @sortOrder()
    @session.order = {}
    @session.order[order_by] = order
    @_refresh()

  newSearch: () =>
    @$el.find('#post-selector').hide()
    if @session
      searchMethod = @defaultSearchMethod
    else
      searchMethod = 'new_session'
    @searchWith(searchMethod, true)

  searchWith: (methodName, new_search, callback, retries=@RETRIES_FOR_TIMEOUT) ->
    if new_search
      @trigger('searchStarted')
    onBeforeSend = () =>
      NProgress.start()
    onSuccess = (dashboardResults) =>
      @page = 0 if (methodName != 'search')
      @page += 1
      @profiles_id ||= dashboardResults.profiles_id
      @session_name = dashboardResults.session_name
      @session ||= dashboardResults.session
      if dashboardResults.error
        @_handleErrors(dashboardResults)
      else
        @massiveTaggingView.setReachedDocument(dashboardResults.total)
        callback = callback || @handleQueryResults
        callback(dashboardResults, new_search)
        NProgress.done()
        @trigger('totalChanges', dashboardResults) if new_search
        @trigger('changeSession', dashboardResults.session) unless (methodName == 'next' or methodName == 'done')
    onError = (response) =>
      console.log('error')
      @_handleErrors(response, methodName, new_search, callback, retries)
    @_doPostRequest(methodName, onSuccess, onError, onBeforeSend)

  _handleErrors: (response, methodName, new_search, callback, retries) ->
    if response.error && response.exception == 'BadRequest'
      swal({
        title: I18n.t('monitoring.dashboard.invalid_query.title'),
        type: 'error',
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.invalid_query.confirm'),
        closeOnConfirm: true
      }, (isConfirm) =>
        NProgress.done()
        @trigger('restoreFromServer')
      )
    else if retries > 0
      @searchWith(methodName, new_search, callback, retries - 1)
    else
      window.showError('An error has occurred. Please try again later')
      NProgress.done()
      @trigger('restoreFromServer')

  _doPostRequest: (methodName, onSuccess, onError, onBeforeSend) =>
    options = @_getSessionOptions()
    page_start = PROFILES_PER_PAGE * @page
    page_end = PROFILES_PER_PAGE * @page + PROFILES_PER_PAGE
    options = {ids: @profiles_id.slice(page_start, page_end)} if methodName == 'search'

    $.ajax(
      type: 'POST',
      url: "/profiling/#{methodName}",
      data: options,
      global: false,
      beforeSend: onBeforeSend,
      success: onSuccess,
      error: onError)

  _getSessionOptions: ->
    return {} unless @session
    session_id: @session.id,
    filter: @session.filter,
    order: @session.order

  _onSearch: =>
    @$el.find('#profile-list').html('')
    @$el.addClass('processing')
    $.ajax
      type: 'POST'
      url: '/profiles/api/search'
      data: { text: @$el.find('#text_search').val() }
      success: @_render_profiles
      error: @_error

  handleQueryResults: (dashboardResults, new_search, container) =>
    if dashboardResults.profiles
      dashboardResults.profiles = dashboardResults.profiles
    if dashboardResults.profiles.length == 0
      @showNoResultsMessage(new_search)
    else
      @clearNoResultsMessage()

    if new_search
      @$resultsContainer.empty()
      @$previousResultsContainer.empty()
      @trigger('searchCompleted', dashboardResults)
      @$el.find('#download').hide()
      @$el.find('#export').show()
    _.each(dashboardResults.profiles, (content) => @addOneToTheEnd(content, Keepcon.tags, container))
    if dashboardResults.total >= 0
      @showTotalResults(dashboardResults.total)
    @uniqueUsers = dashboardResults.total

  showTotalResults: (total) =>
    @$el.find('#results-count').html(total)

  showNoResultsMessage: (new_search) ->
    @$el.find('#previous_results_link').hide()
    if new_search
      @$el.find('#export-div').hide()
      @$el.find('#no_results').removeClass('hide')
      @$el.parents('#results_container').find('#show_charts').hide()

  clearNoResultsMessage: ->
    @$el.find('#previous_results_link').show()
    @$el.find('#export-div').show()
    @$el.find('#no_results').addClass('hide')
    @$el.parents('#results_container').find('#show_charts').show()

  addOneToTheEnd: (socialContent, allTags, container=@$resultsContainer) =>
    @addOne(socialContent, allTags, (element) =>  container.append(element))

  addAndApplyEffect: (view, addFunction) ->
    view.bind('updateResultCount', @updateResultCount)
    element = view.render().$el
    element.hide()
    addFunction(element)
    element.fadeIn()

  updateResultCount: (delta) =>
    resultsCount = @$el.find('#results-count')
    newResult = parseInt(resultsCount.text().match(/\d+/g)) + delta
    newResult = if newResult < 0 then 0 else newResult
    resultsCount.html(newResult)
    @trigger('onReviewCountUpdated', newResult)

  postSelectionPending: ->
    # @searchQuery.get('analysisMode') and not @searchQuery.hasSelectedPosts()

  _socialUsersExportExcel: ->
    @contentExporter = new Process.Methods.ContentExporter({
      actionContainer: @$el.find('#social_users_export_excel'),
      exportableFieldsContainer: @$el.find('#container-exportable-field'),
      searchQuery: @_getSessionOptions(),
      uniqueUsers: @uniqueUsers
    })
    @contentExporter.exportProfiles()

  _onMassiveTagging: =>
    @massiveTaggingView.show()

  _refresh: =>
    @trigger('filterChanged', @session)
